import {
  AGE_KEYS,
  BUY_CAR_INSURANCE_OPTION_TYPES,
  GENDER_TYPE_ENUMS,
  MARITAL_STATUS_TYPE_ENUMS,
  RELATION_TYPE_ENUMS,
} from 'src/utils/constants/BuyPolicy'
import { getFullAddress, getFullName } from 'src/utils/commonMethods/index'
import { updateMemberDetails } from 'src/actions'
import MaleIcon from 'src/assets/Buy_Policy_Images/MaleIcon.svg'
import FemaleIcon from 'src/assets/Buy_Policy_Images/FemaleIcon.svg'
import OthersIcon from 'src/assets/Buy_Policy_Images/Gender_Non_Binary.svg'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import { INSURANCE_SUB_TYPES } from 'src/utils/constants/MyPoliciesData'
import { VEHICLE_NUMBER_REGEX } from 'src/utils/constants/BuyPolicyMotor'

export const isValidAge = (age) => {
  return !!age
}

export const isSelfRelation = (relation) => {
  return relation === RELATION_TYPE_ENUMS.SELF
}

export const isSelfRelationPresent = (memberDetails) => {
  let isSelfPresent = false
  memberDetails.forEach((member) => {
    if (isSelfRelation(member.relation)) {
      isSelfPresent = true
    }
  })
  return isSelfPresent
}

export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) {
    return '-'
  }

  const today = new Date()
  const dob = new Date(dateOfBirth)

  const yearsDiff = today.getFullYear() - dob.getFullYear()

  if (
    today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
  ) {
    return String(yearsDiff - 1) // Return as string
  }

  return String(yearsDiff) // Return as string
}

export const convertDateFormat = (inputDate) => {
  if (!inputDate) {
    return '-'
  }

  const parts = inputDate.split('-')
  if (parts.length !== 3) {
    throw new Error('Invalid date format')
  }

  const [year, month, day] = parts

  return `${day}-${month}-${year}`
}

export const getParentsMinAge = (ageDetails) => {
  if (ageDetails.myAge && ageDetails.spouseAge) {
    return Math.min(ageDetails.myAge, ageDetails.spouseAge)
  } else if (ageDetails.myAge) {
    return ageDetails.myAge
  } else {
    return ageDetails.spouseAge
  }
}

export const isNewCarInsuranceType = (insuranceType) => {
  return insuranceType === BUY_CAR_INSURANCE_OPTION_TYPES.newCar
}

export const convertAmountToLakhs = (amount) => {
  if (amount && amount > 0) {
    return +(amount / 100000).toFixed(2)
  }
  return 0
}

export const generatePastYearsArray = (pastYears) => {
  if (pastYears < 0) {
    throw new Error('The number of past years must be non-negative.')
  }

  const currentYear = new Date().getFullYear()
  const years = []

  for (let i = currentYear; i >= currentYear - pastYears; i--) {
    years.push(i)
  }

  return years
}

export const monthList = [
  { label: 'January', value: '1' },
  { label: 'February', value: '2' },
  { label: 'March', value: '3' },
  { label: 'April', value: '4' },
  { label: 'May', value: '5' },
  { label: 'June', value: '6' },
  { label: 'July', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
]

export const hasFilledKidAge = (data) => {
  let isFilled = false
  data.kidsAge.forEach((kid) => {
    if (isValidAge(kid.age)) {
      isFilled = true
    }
  })
  return isFilled
}

export const getProposerMaritalStatus = (ageDetails) => {
  if (ageDetails.myAge && ageDetails.spouseAge) {
    return MARITAL_STATUS_TYPE_ENUMS.married
  }
  return null
}

export const isKidsPresent = (gender, kidsArray = []) => {
  const filteredKidsArray = kidsArray.filter(
    (kidDetails) => isValidAge(kidDetails.age) && kidDetails.gender === gender
  )
  return !!filteredKidsArray.length
}

export const getUpdatedUserDetails = (
  proposerDetails,
  memberDetails,
  userDetails
) => {
  const ageDetails = {
    kidsAge: [],
  }
  const proposerAge = proposerDetails.dateOfBirth
    ? calculateAge(proposerDetails.dateOfBirth)
    : proposerDetails.age
  memberDetails.forEach((member, index) => {
    const memberAge = member.dateOfBirth
      ? calculateAge(member.dateOfBirth)
      : member.age

    if (AGE_KEYS[member.relation] !== 'kid') {
      ageDetails[AGE_KEYS[member.relation]] = isSelfRelation(member.relation)
        ? proposerAge
        : memberAge
    } else {
      ageDetails.kidsAge.push({
        id: index,
        gender: member.gender,
        age: memberAge,
      })
    }
  })

  if (!isKidsPresent(GENDER_TYPE_ENUMS.MALE, ageDetails.kidsAge)) {
    ageDetails.kidsAge.push({
      id: ageDetails.kidsAge.length + 100,
      gender: GENDER_TYPE_ENUMS.MALE,
      age: '',
    })
  }

  if (!isKidsPresent(GENDER_TYPE_ENUMS.FEMALE, ageDetails.kidsAge)) {
    ageDetails.kidsAge.push({
      id: ageDetails.kidsAge.length + 100,
      gender: GENDER_TYPE_ENUMS.FEMALE,
      age: '',
    })
  }

  return {
    fullName: getFullName([
      proposerDetails.firstName,
      proposerDetails.lastName,
    ]),
    mobileNumber: proposerDetails.phone,
    pincode:
      proposerDetails?.address?.permanentAddress?.pincode ||
      userDetails.pincode,
    gender: proposerDetails.gender,
    ageDetails,
  }
}

export const checkQuoteAndDispatchMemberDetails = (
  guestUserDetails,
  insuranceDetails,
  dispatch
) => {
  if (guestUserDetails.selectedQuote.enquiryId !== insuranceDetails.enquiryId) {
    const memberDetailsList = guestUserDetails.memberDetails
    memberDetailsList.forEach((member) => {
      member.medicalQuestionnaire = null
    })
    dispatch(updateMemberDetails(memberDetailsList))
    return {
      isDifferentQuote: true,
    }
  }
  return {
    isDifferentQuote: false,
  }
}

export const clearAndDispatchMemberDetails = (guestUserDetails, dispatch) => {
  const memberDetailsList = guestUserDetails.memberDetails
  memberDetailsList.forEach((member) => {
    member.medicalQuestionnaire = null
  })
  dispatch(updateMemberDetails(memberDetailsList))
}

export const redirectToHealthHomePage = (guestUserDetails, history) => {
  if (!guestUserDetails.userDetails.gender) {
    history.push('/individual/dashboard/buyPolicy/health/')
  }
}

export const getGenderLogo = (gender) => {
  switch (gender) {
    case GENDER_TYPE_ENUMS.MALE:
      return MaleIcon
    case GENDER_TYPE_ENUMS.FEMALE:
      return FemaleIcon
    default:
      return OthersIcon
  }
}

export const getBuyType = (insuranceType) => {
  switch (insuranceType) {
    case INSURANCE_NAMES.HEALTH_INSURANCE:
      return 'health'
    case INSURANCE_SUB_TYPES.TWO_WHEELER:
      return 'bike'
    case INSURANCE_SUB_TYPES.FOUR_WHEELER:
      return 'motor'
    default:
      return null
  }
}

export const formatLicensePlate = (licensePlate) => {
  // Check if the input is valid
  if (typeof licensePlate !== 'string' || licensePlate.length !== 10) {
    return 'Invalid license plate format'
  }
  const licensePlates = licensePlate.toUpperCase()
  const part1 = licensePlates.slice(0, 4)
  const part2 = licensePlates.slice(4, 6)
  const part3 = licensePlates.slice(6)
  return `${part1}${part2}${part3}`
}

export const validateVehicleNumber = (vehicleNumber) => {
  const vehicleRegex = VEHICLE_NUMBER_REGEX

  return vehicleRegex.test(vehicleNumber)
}

export const createPaProviderObject = (data) => {
  const result = {}

  for (const entry of data) {
    const providerId = entry.providerId
    const paPremium = entry.paPremium
    const type = 'PA_COVER'

    if (paPremium !== null) {
      result[providerId] = {
        paPremium: paPremium,
        type: type,
      }
    }
  }
  return result
}

export const getISNPStatusRequestBody = (
  guestUserDetails,
  category,
  status
) => {
  return {
    name: guestUserDetails?.proposerDetails?.fullName || '',
    mobile: guestUserDetails?.proposerDetails?.phone || '',
    email: guestUserDetails?.proposerDetails?.email || '',
    vehicleNo: null,
    address:
      getFullAddress(
        guestUserDetails?.proposerDetails?.address?.currentAddress
      ) || '',
    category: category,
    currentStatus: status,
  }
}

export const generateAgeList = (startAge = 30, endAge = 85) => {
  const ageList = []
  for (let age = startAge; age <= endAge; age++) {
    ageList.push(age)
  }
  return ageList
}
